const BASE_API_URL = window.location.origin;

const server_transcribe_url = `${BASE_API_URL}/api/transcribe_files/`;
const speaker_tasks_diarization = `${BASE_API_URL}/api/speaker_tasks/diarization/`;
const logout_url = `${BASE_API_URL}/auth/glogout/`;

const WS_PROTOCOL = window.location.protocol === "https:" ? "wss" : "ws";
const WS_BASE_URL = `${WS_PROTOCOL}://${window.location.host}`;

const server_ws_transcribe_url =
  `${WS_BASE_URL}/ws_api/transcribe_files/`;

const close_ws_message_to_server = "recording is stopped";
const token = localStorage.getItem("access_token");

export {
  speaker_tasks_diarization,
  server_transcribe_url,
  logout_url,
  server_ws_transcribe_url,
  close_ws_message_to_server,
  token,
};